/**
 * ResponsavelSaraiva
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelSaraivaCollection} from '@/model/collection/ResponsavelSaraivaCollection'

/* TODO: review generated class */
export class ResponsavelSaraiva extends Resource {
  idResponsavelSaraivaPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  get $id() {
    return this.idResponsavelSaraivaPk
  }
  set $id(val) {
    this.idResponsavelSaraivaPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ResponsavelSaraiva
   */
  async getResponsavelSaraiva(id: number) {
    return await Request.get(`/admin/responsavel-saraiva/${id}`)
      .name('getResponsavelSaraiva')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ResponsavelSaraiva
   */
  static async listResponsavelSaraiva(params: any) {
    return await Request.get(`/admin/responsavel-saraiva`, {params})
      .name('listResponsavelSaraiva')
      .as(ResponsavelSaraivaCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelSaraiva. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelSaraiva() {
    return await Request.post(`/admin/responsavel-saraiva`, this)
      .name('persistResponsavelSaraiva')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelSaraiva to use it in a CSV file
   */
  static async listCsvResponsavelSaraiva(params: any) {
    return await Request.get(`/admin/responsavel-saraiva/csv`, {params})
      .name('listCsvResponsavelSaraiva')
      .as(ResponsavelSaraivaCollection)
      .getData()
  }
}
